import { useStoredUser } from "./storage.mjs";
import { useIdentity } from "./identity.mjs";
import { IS_SECURED_COOKIE } from "../../const/cookies.mjs";
import { useConfigAppMode } from "../config/app-mode.mjs";
import { AUTH_IS_LOGGED_IN, AUTH_USER } from "../../utils/provides.mjs";
import { useCookie, useAsyncData, computed, ref, provide } from "#imports";
export function useAuth() {
  const { appMode } = useConfigAppMode();
  if (appMode === "ssr") {
    return useSsrAuth();
  }
  return useSpaAuth();
}
export function useSsrAuth() {
  const isSecured = useCookie(IS_SECURED_COOKIE);
  const { user, isPendingAuth, setUser } = useStoredUser();
  if (!user.value && isSecured.value) {
    useAsyncData(
      async () => {
        if (isPendingAuth.value && !user.value) {
          await isPendingAuth.value;
          return;
        }
        isPendingAuth.value = useIdentity().identify();
        const fetchedUser = await isPendingAuth.value;
        setUser(fetchedUser);
        isPendingAuth.value = void 0;
      },
      {
        server: false
      }
    );
  }
  const isLoggedIn = computed(() => {
    return !!user.value;
  });
  provide(AUTH_USER, ref(user.value));
  provide(AUTH_IS_LOGGED_IN, isLoggedIn);
  return {
    isLoggedIn,
    user,
    setUser,
    isPendingAuth
  };
}
